<template>
  <div>
    <b-overlay
      :show="submitting"
      spinner-variant="success"
    >
      <b-navbar style="display: flex; flex-direction: row; justify-content: space-between; padding-right: 1vw;" class="header-navbar navbar-shadow align-items-center navbar-brand-center navbar-fixed">
        <b-link
          class="navbar-brand"
          href="https://hoiwa.fi"
        >
          <span class="brand-logo">
            <b-img
              :src="appLogoImage"
              alt="logo"
            />
          </span>
        </b-link>
        <locale />
      </b-navbar>
      <div class="auth-wrapper auth-v3 px-2">
        <div class="auth-inner py-2">
          <h1 class="title">
            {{ $t('tell_about_yourself') }}
          </h1>
          <b-row>
            <b-col cols="12">
              <apply-wizard
                :key="forceReRender"
                :form="form"
                :other-prof="otherProfession"
                :start-index="startIndex"
                @submit="onSubmit"
                @verifyEmail="onVerifyEmail"
                @sendOTP="onSendOTP"
                @verifyOTP="onVerifyOTP"
              />
            </b-col>
          </b-row>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BNavbar,
  BLink,
  BImg,
  BOverlay,
} from 'bootstrap-vue'
import { $themeConfig } from '@theme-config'
import Locale from '@hw-ui/layouts/components/navigation/navbar-top/components/Locale.vue'
import ApplyWizard from '@hw-ui/ui/forms/form-wizard/ApplyWizard.vue'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BNavbar,
    BLink,
    BImg,
    Locale,
    BOverlay,
    ApplyWizard,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      appName: $themeConfig.app.appName,
      appLogoImage: $themeConfig.app.appLogoImage,
      submitting: false,
      startIndex: 0,
      forceReRender: 0,
      form: {
        gender: 'female',
        languages: [],
        carAvailable: false,
        drivingLicense: [],
        address: {},
        permits: [],
        love: false,
        studies: {},
      },
      otherProfession: '',
    }
  },
  methods: {
    async onVerifyEmail({ email, success, fail }) {
      try {
        const result = await this.$store.dispatch('appAuth/isEmailTaken', email)
        if (!result) {
          success()
        } else {
          fail()
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Something went wrong',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async onSendOTP({ email, success, fail }) {
      try {
        const result = await this.$store.dispatch('appAuth/sendOTP', email)
        if (!result) {
          success()
        } else {
          fail()
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Something went wrong',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async onVerifyOTP({
      email,
      OTP,
      success,
      fail,
    }) {
      try {
        await this.$store.dispatch('appAuth/verifyOTP', { email, OTP })
        success()
      } catch {
        fail()
      }
    },
    async onSubmit(submission) {
      this.submitting = true
      const user = submission.form
      const { OTP } = submission
      user.fullName = `${user.firstName} ${user.lastName}`
      user.status = 'pending'
      user.confirmed = false
      user.isAdmin = false
      user.role = user.profession
      user.files = []
      try {
        await this.$store.dispatch('appAuth/createApplication', { user, OTP })
        this.$swal({
          title: 'Hakemus Lähetetty!',
          text: 'Kiitos hakemuksestasi. Olemme pian yhteydessä teihin.',
          icon: 'success',
          backdrop: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          confirmButtonText: 'Palaa Etusivulle',
          buttonsStyling: false,
        }).then(() => {
          window.location.href = 'https://hoiwa.fi'
        })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Something went wrong. Please try again.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        this.submitting = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/pages/page-auth.scss';
@import '@hw-ui/scss/vue/libs/vue-wizard.scss';
@import '@hw-ui/scss/vue/libs/vue-select.scss';

.title {
  padding-bottom: 15px;
}
.navbar-brand {
  margin-left: 10px;
}
.brand-logo {
  img {
    width: 50px;
  }
}

.auth-wrapper {
  min-height: 500px!important;
}
.auth-wrapper.auth-v3 {
    margin-top: 100px;
    justify-content: center;
}
.auth-wrapper.auth-v3 .auth-inner {
    max-width: 1000px;
}
.brand-logo {
  width: 50px;
}

.wizard-nav {
  width: 274px;
}
@media only screen and (max-width: 767px) {
  .auth-wrapper.auth-v3 {
    margin-top: 0;
    .vertical-steps.vue-form-wizard .wizard-navigation .wizard-nav {
      width: 100%;
      padding: 0 0 1.5rem 0;
      flex-direction: row;
      justify-content: space-around;
      li {
        display: inline;
        padding-bottom: 0;
        &:last-child {
          margin-right: 0;
        }
        a {
          display: inherit;
          div.wizard-icon-circle{
            display: inline-flex;
            margin-right: 0;
          }
          .stepTitle {
            display: none;
          }
        }
      }
    }
  }
}
</style>
